import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "../Pages/Home";
import NotFound from "./NotFound";
import Navbar from "../Pages/Navbar";
import GameList from "../Pages/GameList";
import PlayGame from "../Components/PlayGame";
import Footer from "../Pages/Footer";
import BottomNav from "../Components/BottomNav";
import About from "../Pages/About";
import BlogPost from "./BlogPost";
import ContactUs from "./Contact";
import Terms from "./Terms";
import PrivacyPolicy from "./Privacy";

export function Manage() {
  const location = useLocation();

  const isNotFound = !["/", "/games", "/about", "/privacy-policy" , "/contact" , "/terms"].some(
    (path) => location.pathname === path) && !location.pathname.startsWith("/play/") && !location.pathname.startsWith("/blog/");

  return (
    <>
      {!isNotFound && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/games" element={<GameList />} />
        <Route path="/play/:slug" element={<PlayGame />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/contact" element={<ContactUs/>} />
        <Route path="/terms" element={<Terms/>} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!isNotFound && (
        <>
          <div className="md:hidden">
            <BottomNav />
          </div>
          <Footer />
        </>
      )}
    </>
  );
}

